export const siteName = 'CSB Schimmel Automobile';

export const GTM_ID = 'GTM-MV4QGRR';

// Sponsoring-Badge "Vereinsförderung" (Füchse Berlin) im PageHeader.
// Die Partnerschaft ist zur laufenden Saison ausgelaufen - auf `true` setzen,
// um das Testimonial site-weit wieder einzublenden.
export const ENABLE_FUECHSE_BERLIN_PROMOTION = false;

export const layoutWidth = {
  width100: 12,
  width75: 9,
  width66: 8,
  width50: 6,
  width33: 4,
  width25: 3,
};

// https://github.com/lipis/flag-icons/tree/main/flags/4x3
export const LOCALES = {
  de: {
    icon: '/images/flags/de.svg',
  },
  en: {
    icon: '/images/flags/uk.svg',
  },
  es: {
    icon: '/images/flags/es.svg',
  },
  ru: {
    icon: '/images/flags/ru.svg',
  },
  vi: {
    icon: '/images/flags/vn.svg',
  },
  tr: {
    icon: '/images/flags/tr.svg',
  },
};

export const gdprConfig = {
  acceptAll: true,
  htmlTexts: true,
  translations: {
    de: {
      acceptAll: 'Alle Cookies akzeptieren',
      ok: 'Alle Cookies akzeptieren',
      decline: 'Alle optionalen Cookies ablehnen',
      acceptSelected: 'Individuelle Auswahl bestätigen',
      privacyPolicyUrl: '/datenschutz',
      consentNotice: {
        description: '<div class="klaro-brand-logo"><img loading="lazy" src="/images/brand/brand-logo-inverted.svg" alt="Schimmel Automobile" id="id-cookie-title" width="150" height="40" /></div>Um unser Webangebot zu verbessern und diese Seite optimal für unsere Besucher zu gestalten, setzen wir und auch unsere Partner, dessen Dienste wir nutzen, Technologien wie Cookies ein. Auch ein Austausch von IP-Adressen unserer Webseitenbesucher mit unseren Partnern kann stattfinden.<br /><br />Die Setzung einiger Cookies ist zwingend erforderlich. Für bestimmte Dienste benötigen wir Ihre Einwilligung.<br /><br />Durch den Klick auf „Alle Cookies akzeptieren“, willigen Sie (jederzeit für die Zukunft widerruflich) in alle Datenverarbeitungen (Setzung von Cookies und Übermittlung der IP-Adresse an Partner) ein.<br /><br />Durch den Klick „ Alle optionalen Cookies ablehnen“ werden alle nicht zwingend notwendigen Cookies nicht gesetzt und Verbindungen unterbunden. Die Nutzung unserer Webseite ist dann stark eingeschränkt.<br /><br />Durch den Klick auf „ Lassen Sie mich wählen“ können Einstellungen geändert und der Datenverarbeitung eingewilligt werden. Ihre Auswahl kann jederzeit angepasst werden.<br /><br />Hinweis auf Verarbeitung der Daten in den USA (z.B. durch Google, Facebook, Youtube): Durch den Klick auf „Alle Cookies akzeptieren" oder bei der entsprechenden Auswahl eines Anbieters, willigen Sie zugleich darin ein, dass Ihre Daten in den USA verarbeitet werden. Die USA wird als ein Land mit einem nicht ausreichenden Datenschutzniveau angesehen. Es besteht u.a. das Risiko, dass Ihre Daten durch US-Behörden, zu Kontroll- und zu Überwachungszwecken, möglicherweise auch ohne Rechtsbehelfsmöglichkeiten, verarbeitet werden können. Bei dem Klick auf „Alle optionalen Cookies ablehnen“, findet keine Datenübermittlung statt.<br /><br />Weitere Informationen finden Sie unter <a href="/datenschutz">Datenschutz</a>. Zum <a href="/impressum">Impressum</a>.',
      },
      privacyPolicy: {
        name: 'Datenschutz',
        text: 'Weitere Informationen finden Sie unter {privacyPolicy}. Zum <a href="/impressum">Impressum</a>.<br /><br />Hier finden Sie eine Übersicht über alle verwendeten Cookies und eingebundener Dienste und können eine individuelle Auswahl treffen: ',
      },
      consentModal: {
        description:
          'Durch den Klick auf „Alle Cookies akzeptieren“, willigen Sie (jederzeit für die Zukunft widerruflich) in alle Datenverarbeitungen (Setzung von Cookies und Übermittlung der IP-Adresse an Partner) ein.<br /><br />Durch den Klick „Alle optionalen Cookies ablehnen“ werden alle nicht zwingend notwendigen Cookies nicht gesetzt und Verbindungen unterbunden. Die Nutzung unserer Webseite ist dann stark eingeschränkt.<br /><br />Hinweis auf Verarbeitung der Daten in den USA (z.B. durch Google, Facebook, Youtube): Durch den Klick auf „Alle Cookies akzeptieren" oder bei der entsprechenden Auswahl eines Anbieters, willigen Sie zugleich darin ein, dass Ihre Daten in den USA verarbeitet werden. Die USA wird als ein Land mit einem nicht ausreichenden Datenschutzniveau angesehen. Es besteht u.a. das Risiko, dass Ihre Daten durch US-Behörden, zu Kontroll- und zu Überwachungszwecken, möglicherweise auch ohne Rechtsbehelfsmöglichkeiten, verarbeitet werden können.<br /><br />',
      },
      contextualConsent: {
        description: 'Möchten Sie von {title} bereitgestellte externe Inhalte laden?',
        acceptAlways: 'Weiter',
      },
      purposes: {
        essential: {
          title: 'Essenziell',
          description: 'Essenzielle Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.',
        },
        analytics: {
          title: 'Statistiken',
          description: 'Statistik Cookies erfassen Informationen anonym. Diese Informationen helfen uns zu verstehen, wie Besucher unsere Website nutzen.',
        },
        marketing: {
          title: 'Marketing',
          description: 'Marketing Cookies werden von Drittanbietern oder Publishern verwendet, um personalisierte Werbung anzuzeigen. Sie tun dies, indem sie Besucher über Websites hinweg verfolgen.',
        },
        externalContent: {
          title: 'Externe Medien',
          description: 'Inhalte von Videoplattformen und Social-Media Plattformen werden standardmäßig blockiert. Wenn Cookies von externen Medien akzeptiert werden, bedarf der Zugriff auf diese Inhalte keiner manuellen Einwilligung mehr.',
        },
      },
    },
    en: {
      acceptAll: 'Accept all cookies',
      ok: 'Accept all cookies',
      decline: 'Decline all optional cookies',
      acceptSelected: 'Confirm individual selection',
      privacyPolicyUrl: '/privacy',
      consentNotice: {
        description: '<div class="klaro-brand-logo"><img loading="lazy" src="/images/brand/brand-logo-inverted.svg" alt="Schimmel Automobile" id="id-cookie-title" width="150" height="40" /></div>To improve our website and tailor it optimally for our visitors, we and our partners, whose services we use, employ technologies such as cookies. An exchange of IP addresses of our website visitors with our partners may also occur.<br /><br />The setting of some cookies is essential. For certain services, we require your consent.<br /><br />By clicking "Accept all cookies", you consent (revocable at any time for the future) to all data processing (setting of cookies and transmission of the IP address to partners).<br /><br />By clicking "Decline all optional cookies", all non-essential cookies will not be set, and connections will be blocked. The use of our website will then be severely limited.<br /><br />By clicking "Let me choose", settings can be changed, and consent to data processing can be given. Your selection can be adjusted at any time.<br /><br />Notice of data processing in the USA (e.g., by Google, Facebook, Youtube): By clicking "Accept all cookies" or selecting a provider accordingly, you also consent to your data being processed in the USA. The USA is considered a country with insufficient data protection levels. There is a risk, among other things, that your data may be processed by US authorities for control and monitoring purposes, possibly without any legal remedies. No data transmission occurs when clicking "Decline all optional cookies".<br /><br />For more information, please see our <a href="/privacy">privacy policy</a>. Go to <a href="/imprint">imprint</a>.',
      },
      privacyPolicy: {
        name: 'Privacy Policy',
        text: 'For more information, please see our {privacyPolicy}. Go to <a href="/imprint">imprint</a>.<br /><br />Here you will find an overview of all cookies used and embedded services, and can make an individual selection: ',
      },
      consentModal: {
        description: 'By clicking "Accept all cookies", you consent (revocable at any time for the future) to all data processing (setting of cookies and transmission of the IP address to partners).<br /><br />By clicking "Decline all optional cookies", all non-essential cookies will not be set, and connections will be blocked. The use of our website will then be severely limited.<br /><br />Notice of data processing in the USA (e.g., by Google, Facebook, Youtube): By clicking "Accept all cookies" or selecting a provider accordingly, you also consent to your data being processed in the USA. The USA is considered a country with insufficient data protection levels. There is a risk, among other things, that your data may be processed by US authorities for control and monitoring purposes, possibly without any legal remedies.<br /><br />',
      },
      contextualConsent: {
        description: 'Do you want to load external content provided by {title}?',
        acceptAlways: 'Continue',
      },
      purposes: {
        essential: {
          title: 'Essential',
          description: 'Essential cookies enable basic functions and are necessary for the proper functioning of the website.',
        },
        analytics: {
          title: 'Statistics',
          description: 'Statistic cookies collect information anonymously. These cookies help us understand how visitors use our website.',
        },
        marketing: {
          title: 'Marketing',
          description: 'Marketing cookies are used by third-party advertisers or publishers to display personalized ads. They do this by tracking visitors across websites.',
        },
        externalContent: {
          title: 'External Media',
          description: 'Content from video platforms and social media platforms is blocked by default. If cookies from external media are accepted, access to this content no longer requires manual consent.',
        },
      },
    },
    es: {
      acceptAll: 'Aceptar todas las cookies',
      ok: 'Aceptar todas las cookies',
      decline: 'Rechazar todas las cookies opcionales',
      acceptSelected: 'Confirmar selección individual',
      privacyPolicyUrl: '/politica-de-privacidad',
      consentNotice: {
        description: '<div class="klaro-brand-logo"><img loading="lazy" src="/images/brand/brand-logo-inverted.svg" alt="Schimmel Automobile" id="id-cookie-title" width="150" height="40" /></div>Para mejorar nuestra página web y adaptarla de forma óptima a nuestros visitantes, nosotros y nuestros socios, cuyos servicios utilizamos, empleamos tecnologías como cookies. También puede ocurrir un intercambio de direcciones IP de nuestros visitantes del sitio web con nuestros socios.<br /><br />La configuración de algunas cookies es esencial. Para ciertos servicios, requerimos su consentimiento.<br /><br />Al hacer clic en "Aceptar todas las cookies", usted acepta (revocable en cualquier momento para el futuro) todos los procesos de datos (configuración de cookies y transmisión de la dirección IP a los socios).<br /><br />Al hacer clic en "Rechazar todas las cookies opcionales", todas las cookies no esenciales no se establecerán y se bloquearán las conexiones. El uso de nuestro sitio web se verá gravemente limitado.<br /><br />Al hacer clic en "Déjame elegir", se pueden cambiar las configuraciones y se puede otorgar el consentimiento para el procesamiento de datos. Su selección se puede ajustar en cualquier momento.<br /><br />Aviso de procesamiento de datos en los EE. UU. (por ejemplo, por Google, Facebook, Youtube): Al hacer clic en "Aceptar todas las cookies" o seleccionar un proveedor en consecuencia, también acepta que sus datos se procesen en los EE. UU. Los EE. UU. se consideran un país con niveles de protección de datos insuficientes. Existe un riesgo, entre otras cosas, de que sus datos sean procesados por las autoridades estadounidenses con fines de control y monitoreo, posiblemente sin ningún recurso legal. No hay transmisión de datos al hacer clic en "Rechazar todas las cookies opcionales".<br /><br />Para obtener más información, consulte nuestra <a href="/politica-de-privacidad">política de privacidad</a>. Ir al <a href="/imprint">impreso</a>.',
      },
      privacyPolicy: {
        name: 'Política de privacidad',
        text: 'Para obtener más información, consulte nuestra {privacyPolicy}. Ir al <a href="/imprint">impreso</a>.<br /><br />Aquí encontrará una descripción general de todas las cookies utilizadas y los servicios integrados, y podrá realizar una selección individual: ',
      },
      consentModal: {
        description: 'Al hacer clic en "Aceptar todas las cookies", usted acepta (revocable en cualquier momento para el futuro) todos los procesos de datos (configuración de cookies y transmisión de la dirección IP a los socios).<br /><br />Al hacer clic en "Rechazar todas las cookies opcionales", todas las cookies no esenciales no se establecerán y se bloquearán las conexiones. El uso de nuestro sitio web se verá gravemente limitado.<br /><br />Aviso de procesamiento de datos en los EE. UU. (por ejemplo, por Google, Facebook, Youtube): Al hacer clic en "Aceptar todas las cookies" o seleccionar un proveedor en consecuencia, también acepta que sus datos se procesen en los EE. UU. Los EE. UU. se consideran un país con niveles de protección de datos insuficientes. Existe un riesgo, entre otras cosas, de que sus datos sean procesados por las autoridades estadounidenses con fines de control y monitoreo, posiblemente sin ningún recurso legal.<br /><br />',
      },
      contextualConsent: {
        description: '¿Desea cargar contenido externo proporcionado por {title}?',
        acceptAlways: 'Continuar',
      },
      purposes: {
        essential: {
          title: 'Esencial',
          description: 'Las cookies esenciales permiten funciones básicas y son necesarias para el correcto funcionamiento del sitio web.',
        },
        analytics: {
          title: 'Estadísticas',
          description: 'Las cookies estadísticas recopilan información de forma anónima. Esta información nos ayuda a comprender cómo los visitantes utilizan nuestro sitio web.',
        },
        marketing: {
          title: 'Marketing',
          description: 'Las cookies de marketing son utilizadas por anunciantes o editores de terceros para mostrar anuncios personalizados. Lo hacen rastreando a los visitantes en diferentes sitios web.',
        },
        externalContent: {
          title: 'Contenido externo',
          description: 'El contenido de plataformas de video y redes sociales está bloqueado por defecto. Si se aceptan cookies de medios externos, el acceso a este contenido ya no requiere consentimiento manual.',
        },
      },
    },
    tr: {
      acceptAll: 'Tüm çerezleri kabul et',
      ok: 'Tüm çerezleri kabul et',
      decline: 'Tüm isteğe bağlı çerezleri reddet',
      acceptSelected: 'Seçilenleri kabul et',
      privacyPolicyUrl: '/gizlilik-politikasi',
      consentNotice: {
        description: '<div class="klaro-brand-logo"><img loading="lazy" src="/images/brand/brand-logo-inverted.svg" alt="Schimmel Automobile" id="id-cookie-title" width="150" height="40" /></div>Web sitemizi iyileştirmek ve ziyaretçilerimiz için bu sayfayı en iyi şekilde düzenlemek için, kullandığımız teknolojiler arasında çerezleri kullanıyoruz, aynı zamanda iş ortaklarımızın da hizmetlerini kullanıyoruz. Web sitemizin ziyaretçilerinin IP adreslerinin iş ortaklarımıza aktarılması da mümkündür.<br /><br />Bazı çerezlerin ayarlanması zorunludur. Belirli hizmetler için izniniz gerekebilir.<br /><br />"Tüm çerezleri kabul et"e tıkladığınızda, tüm veri işlemlerine (çerezlerin ayarlanması ve IP adresinin iş ortaklarına aktarılması) her zaman geri alınabilen şekilde izin vermiş olursunuz.<br /><br />"Tüm isteğe bağlı çerezleri reddet"e tıkladığınızda, tüm zorunlu olmayan çerezler ayarlanmaz ve bağlantılar kesilir. Web sitemizin kullanımı büyük ölçüde kısıtlanır.<br /><br />"Seçmeme izin ver"e tıkladığınızda, ayarlarınızı değiştirebilir ve veri işleme izni verebilirsiniz. Seçiminiz her zaman değiştirilebilir.<br /><br />Veri işleme uyarısı (örneğin, Google, Facebook, Youtube tarafından): "Tüm çerezleri kabul et"e tıkladığınızda veya uygun bir sağlayıcıyı seçtiğinizde, ayrıca verilerinizin ABD,de işlenmesini kabul etmiş olursunuz. ABD, yetersiz veri koruma düzeyine sahip bir ülke olarak kabul edilmektedir. Bu, verilerinizin ABD yetkilileri tarafından kontrol ve izleme amaçlarıyla işlenebileceği, muhtemelen herhangi bir yasal koruma olmadan gerçekleşebilecek bir risk bulunduğu anlamına gelmektedir.<br /><br /><a href="/gizlilik-politikasi">Gizlilik Politikası</a> için daha fazla bilgiyi burada bulabilirsiniz. <a href="/impressum">İletişim Bilgileri</a>.',
      },
      privacyPolicy: {
        name: 'Gizlilik Politikası',
        text: 'Daha fazla bilgi için lütfen {privacyPolicy} bölümümüze bakınız. <a href="/impressum">İletişim Bilgileri</a>.<br /><br />Kullanılan tüm çerezlerin ve entegre edilen hizmetlerin genel bir açıklamasını burada bulabilir ve bireysel bir seçim yapabilirsiniz: ',
      },
      consentModal: {
        description: 'Durch den Klick auf „Alle Cookies akzeptieren“, willigen Sie (jederzeit für die Zukunft widerruflich) in alle Datenverarbeitungen (Setzung von Cookies und Übermittlung der IP-Adresse an Partner) ein.<br /><br />Durch den Klick „Alle optionalen Cookies ablehnen“ werden alle nicht zwingend notwendigen Cookies nicht gesetzt und Verbindungen unterbunden. Die Nutzung unserer Webseite ist dann stark eingeschränkt.<br /><br />Hinweis auf Verarbeitung der Daten in den USA (z.B. durch Google, Facebook, Youtube): Durch den Klick auf „Alle Cookies akzeptieren" oder bei der entsprechenden Auswahl eines Anbieters, willigen Sie zugleich darin ein, dass Ihre Daten in den USA verarbeitet werden. Die USA wird als ein Land mit einem nicht ausreichenden Datenschutzniveau angesehen. Es besteht u.a. das Risiko, dass Ihre Daten durch US-Behörden, zu Kontroll- und zu Überwachungszwecken, möglicherweise auch ohne Rechtsbehelfsmöglichkeiten, verarbeitet werden können.<br /><br />',
      },
      contextualConsent: {
        description: '{title} tarafından sağlanan harici içeriği yüklemek ister misiniz?',
        acceptAlways: 'Devam',
      },
      purposes: {
        essential: {
          title: 'Esas',
          description: 'Esas çerezler temel işlevleri etkinleştirir ve web sitesinin düzgün çalışması için gereklidir.',
        },
        analytics: {
          title: 'Analitik',
          description: 'Analitik çerezler bilgileri anonim olarak toplar. Bu bilgiler, ziyaretçilerimizin web sitemizi nasıl kullandığını anlamamıza yardımcı olur.',
        },
        marketing: {
          title: 'Pazarlama',
          description: 'Pazarlama çerezleri üçüncü taraf reklamverenler veya yayıncılar tarafından kişiselleştirilmiş reklamlar göstermek için kullanılır. Bunlar, ziyaretçileri farklı web sitelerinde izleyerek yaparlar.',
        },
        externalContent: {
          title: 'Harici İçerik',
          description: 'Video platformlarından ve sosyal medya platformlarından içerikler varsayılan olarak engellenmiştir. Harici medya çerezleri kabul edilirse, bu içeriğe erişim artık manuel onay gerektirmez.',
        },
      },
    },
    ru: {
      acceptAll: 'Принять все файлы cookie',
      ok: 'Принять все файлы cookie',
      decline: 'Отклонить все дополнительные файлы cookie',
      acceptSelected: 'Подтвердить индивидуальный выбор',
      privacyPolicyUrl: '/datenschutz',
      consentNotice: {
        description: '<div class="klaro-brand-logo"><img loading="lazy" src="/images/brand/brand-logo-inverted.svg" alt="Schimmel Automobile" id="id-cookie-title" width="150" height="40" /></div>Для улучшения нашего веб-предложения и оптимизации этой страницы для наших посетителей мы и наши партнеры, чьи услуги мы используем, используем технологии, такие как файлы cookie. Также возможен обмен IP-адресами наших веб-посетителей с нашими партнерами.<br /><br />Установка некоторых файлов cookie обязательна. Для определенных услуг нам необходимо ваше согласие.<br /><br />Нажав на кнопку "Принять все файлы cookie", вы соглашаетесь (в любое время отзывается) на все обработки данных (установка файлов cookie и передача IP-адреса партнерам).<br /><br />Нажав на кнопку "Отклонить все дополнительные файлы cookie", вы не разрешаете установку всех необязательных файлов cookie и прерываете связи. Использование нашего веб-сайта будет сильно ограничено.<br /><br />Нажав на кнопку "Позвольте мне выбирать", вы можете изменить настройки и согласиться на обработку данных. Ваш выбор может быть изменен в любое время.<br /><br />Примечание о обработке данных в США (например, Google, Facebook, Youtube): Нажав на кнопку "Принять все файлы cookie" или выбрав соответствующего поставщика, вы также соглашаетесь на обработку ваших данных в США. США рассматриваются как страна с недостаточным уровнем защиты данных. Существует риск того, что ваши данные могут быть обработаны американскими органами без возможности правовой защиты.<br /><br />Дополнительную информацию вы найдете в <a href="/datenschutz">политике конфиденциальности</a>. К <a href="/impressum">Контактной информации</a>.',
      },
      privacyPolicy: {
        name: 'Политика конфиденциальности',
        text: 'Дополнительную информацию вы найдете в {privacyPolicy}. К <a href="/impressum">Контактной информации</a>.<br /><br />Здесь вы найдете обзор всех использованных файлов cookie и встроенных служб, а также сможете сделать индивидуальный выбор:',
      },
      consentModal: {
        description: 'Нажав на кнопку "Принять все файлы cookie", вы соглашаетесь (в любое время отзывается) на все обработки данных (установка файлов cookie и передача IP-адреса партнерам).<br /><br />Нажав на кнопку "Отклонить все дополнительные файлы cookie", вы не разрешаете установку всех необязательных файлов cookie и прерываете связи. Использование нашего веб-сайта будет сильно ограничено.<br /><br />Примечание о обработке данных в США (например, Google, Facebook, Youtube): Нажав на кнопку "Принять все файлы cookie" или выбрав соответствующего поставщика, вы также соглашаетесь на обработку ваших данных в США. США рассматриваются как страна с недостаточным уровнем защиты данных. Существует риск того, что ваши данные могут быть обработаны американскими органами без возможности правовой защиты.',
      },
      contextualConsent: {
        description: 'Хотели бы вы загрузить внешние контенты, предоставленные {title}?',
        acceptAlways: 'Далее',
      },
      purposes: {
        essential: {
          title: 'Основные',
          description: 'Основные файлы cookie обеспечивают основные функции и необходимы для правильной работы веб-сайта.',
        },
        analytics: {
          title: 'Аналитика',
          description: 'Файлы cookie для аналитики собирают информацию анонимно. Эта информация помогает нам понять, как посетители используют наш веб-сайт.',
        },
        marketing: {
          title: 'Маркетинг',
          description: 'Файлы cookie маркетинга используются третьими сторонами или издателями для отображения персонализированной рекламы. Они делают это, отслеживая посетителей на разных веб-сайтах.',
        },
        externalContent: {
          title: 'Внешний контент',
          description: 'Контент с видеоплатформ и социальных медиа-платформ по умолчанию заблокирован. Если файлы cookie от внешних медиа-платформ разрешены, доступ к этому контенту не требует дополнительного согласия.',
        },
      },
    },
  },
  services: [
    // essential
    /* {
      required: true,
      name: 'provenexpert',
      title: 'Cloudflare',
      purposes: ['essential'],
      description: createServiceDescription({
        vendor: 'Cloudflare Inc.',
        purpose: 'Cloudflare stellt die Infrastruktur für die
        DNS-Auflösung und die Bereitstellung unserer Inhalte (CDN) zur Verfügung.',
        privacyUrl: 'https://www.cloudflare.com/de-de/privacypolicy/'
      })
    },
    {
      required: true,
      name: 'provenexpert',
      title: 'DigitalOcean',
      purposes: ['essential'],
      description: createServiceDescription({
        vendor: 'DigtialOcean LLC',
        purpose: 'DigitalOcean stellt die Cloud-Infrastruktur
        für unsere Web Anwendungen und Datenbanken zur Verfügung.',
        privacyUrl: 'https://www.digitalocean.com/legal/privacy-policy/'
      })
    }, */
    // analytics
    {
      name: 'googleAnalytics',
      title: 'Google Tag Manager & Google Anayltics',
      purposes: ['analytics'],
      description: createServiceDescription({
        vendor: 'Google Ireland Limited',
        purpose: 'Cookie von Google zur Steuerung von Google Analytics und der erweiterten Script- und Ereignisbehandlung.',
        privacyUrl: 'https://policies.google.com/privacy',
        cookies: [
          { name: '_gid', expire: '1 Tag' },
          { name: '_ga', expire: '2 Jahre' },
          { name: '_gat_gtag_UA_62061092_1', expire: '1 Tag' },
          { name: 'IDE', expire: '1 Jahr' },
          { name: 'RUL', expire: '1 Jahr' },
        ],
      }),
    },
    // marketing
    {
      name: 'facebook',
      title: 'Facebook Tracking Pixel',
      purposes: ['marketing'],
      description: createServiceDescription({
        vendor: 'Facebook Ireland Limited',
        purpose: 'Durch diesen Cookie kann das Verhalten von Nutzern nachverfolgt werden. Dieses Verfahren dient dazu, die Wirksamkeit der Facebook-Werbeanzeigen für statistische und Marktforschungszwecke auszuwerten und kann dazu beitragen, zukünftige Werbemaßnahmen zu optimieren.',
        privacyUrl: 'https://www.facebook.com/about/privacy',
        cookies: [
          { name: 'fr', expire: '3 Monate' },
          { name: '_fbp', expire: '3 Monate' },
          { name: 'sb', expire: '2 Jahre' },
          { name: 'datr', expire: '2 Jahre' },
          { name: 'dpr', expire: '2 Wochen' },
          { name: 'wd', expire: '2 Wochen' },
        ],
      }),
    },
    {
      name: 'LinkedIn',
      title: 'LinkedIn Tracking Pixel',
      purposes: ['marketing'],
      description: createServiceDescription({
        vendor: 'LinkedIn Ireland Unlimited Company',
        purpose: 'Diese Datenschutzerklärung gilt für die Verarbeitung von personenbezogenen Daten durch LinkedIn im Zusammenhang mit den Anwendungen, den Webseiten, der Software und den zugehörigen Diensten von LinkedIn.',
        privacyUrl: 'https://de.linkedin.com/legal/privacy-policy',
        cookies: [],
      }),
    },
    {
      name: 'tiktok',
      title: 'TikTok Tracking Pixel',
      purposes: ['marketing'],
      description: createServiceDescription({
        vendor: 'TikTok Pte. Ltd.',
        purpose: 'Diese Datenschutzerklärung gilt für die Verarbeitung von personenbezogenen Daten durch TikTok im Zusammenhang mit den Anwendungen, den Webseiten, der Software und den zugehörigen Diensten von TikTok.',
        privacyUrl: 'https://www.tiktok.com/legal/page/eea/privacy-policy/de-DE',
        cookies: [],
      }),
    },
    // externalContent
    /* {
      name: 'browserUpdate',
      title: 'Browser Update',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Thomas Hümmer Webentwicklung',
        purpose: 'Mittels Browser Update werden Benutzer über Updates für
        ihren Webbrowser informiert, die ggfs. für die einwandfreie Funktio
        der Website erforderlich sind.',
        privacyUrl: 'https://browser-update.org/privacy-policy-site.html'
      })
    }, */
    {
      name: 'partsStore',
      title: 'IT-Tecture Fahrzeugbörse & Teileshop',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Dr. Schnell & Dr. Hensel GmbH',
        purpose: 'Mittels ServiceLister werden Zubehörteile für Fahrzeuge angeboten.',
        privacyUrl: 'https://www.servicelister.de/Start/legal/datenschutzerklaerung.html',
        cookies: [
          { name: '_GRECAPTCHA', expire: '6 Monate' },
          { name: 'NID', expire: '6 Monate' },
          { name: '1P_JAR', expire: '1 Monat' },
          { name: 'CONSENT', expire: '20 Jahre' },
          { name: 'DV', expire: '1 Tag' },
        ],
      }),
    },
    {
      name: 'googleMaps',
      title: 'Google Maps',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Google Ireland Limited',
        purpose: 'Wird zum Entsperren von Google-Maps Kartendiensten verwendet.',
        privacyUrl: 'https://policies.google.com/privacy',
      }),
    },
    {
      name: 'youtube',
      title: 'Youtube',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Google Ireland Limited',
        purpose: 'Wird zum Entsperren von Youtube Videos verwendet.',
        privacyUrl: 'https://policies.google.com/privacy',
        cookies: [
          { name: '__Secure-3PAPISID', expire: '2 Jahre' },
          { name: '__Secure-3PSID', expire: '2 Jahre' },
          { name: '__Secure-3PSIDCC', expire: '1 Jahr' },
          { name: 'CONSENT', expire: '20 Jahre' },
          { name: 'GPS', expire: '1 Tag' },
          { name: '_gcl_au', expire: '2 Monate' },
          { name: 'VISITOR_INFO1_LIVE', expire: '6 Monate' },
          { name: 'YSC', expire: 'Session' },
          { name: 'wide', expire: 'Session' },
          { name: 'PREF', expire: '2 Jahre' },
        ],
      }),
    },
    {
      name: 'provenexpert',
      title: 'Proven Expert',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Expert Systems AG',
        purpose: 'Wird zum Entsperren von Unternehmens-Bewertungs-Widgets von Proven Expert verwendet.',
        privacyUrl: 'https://www.provenexpert.com/de-de/datenschutzbestimmungen/',
      }),
    },
    {
      name: 'softgarden',
      title: 'Softgarden',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'softgarden e-recruiting GmbH',
        purpose: 'Wird zum Entsperren von Arbeitgeber-Bewertungs-Widgets von Softgarden verwendet.',
        privacyUrl: 'https://softgarden.de/unternehmen/datenschutz-webseite/',
      }),
    },
    {
      name: 'santander',
      title: 'Santander Finanzierungsrechner',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Santander Consumer Bank AG',
        purpose: 'Mittels Santander Finanzierungsrechner kann die monatliche Rate für eine Fahrzeugfinanzierung berechnet werden.',
        privacyUrl: 'https://www.santander.de/privatkunden/service-kontakt/datenschutz/',
        cookies: [
          { name: 'visid_incap_2304632', expire: '1 Jahr' },
          { name: 'incap_ses_875_2304632', expire: 'Session' },
        ],
      }),
    },
    {
      name: 'bdk',
      title: 'BDK Fahrzeugkonfigurator',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'Bank Deutsches Kraftfahrzeuggewerbe GmbH',
        purpose: 'Der Fahrzeugkonfigurator der BDK ermöglicht die Konfiguration von neuen Pkws durch den Kunden.',
        privacyUrl: 'https://www.bdk-bank.de/unternehmen/datenschutz/',
        cookies: [
          { name: 'visid_incap_2304632', expire: '1 Jahr' },
          { name: 'incap_ses_875_2304632', expire: 'Session' },
        ],
      }),
    },
    {
      name: 'autouncle',
      title: 'AutoUncle Preisvergleich',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'AutoUncle Aps',
        purpose: 'Der AutoUncle Preisvergleich bewertet den Preis eines angebotenen Fahrzeuges hinsichtlich seiner Attraktivität für den Kunden.',
        privacyUrl: 'https://www.autouncle.de/de/impressum-und-datenschutz',
      }),
    },
    {
      name: 'paypal',
      title: 'PayPal Plus',
      purposes: ['externalContent'],
      description: createServiceDescription({
        vendor: 'PayPal (Europe) S.à r.l. et Cie, S.C.A.',
        purpose: 'PayPal dient als Zahlungsdienstleister, um Käufe in der Fahrzeugsuche und beim Zubehörshop abzuwickeln.',
        privacyUrl: 'https://www.paypal.com/de/webapps/mpp/ua/privacy-full',
        cookies: [
          { name: 'paypalplus_session_v2', expire: 'Session' },
        ],
      }),
    },
  ],
};

function createServiceDescription(data) {
  const {
    vendor,
    purpose,
    privacyUrl,
    cookies,
  } = data;

  let description = '<div class="service-details-container"><table class="service-details"><tbody>';

  if (vendor) {
    description += `<tr><td>Anbieter</td><td>${vendor}</td></tr>`;
  }

  if (purpose) {
    description += `<tr><td>Zweck</td><td>${purpose}</td></tr>`;
  }

  if (privacyUrl) {
    description += `<tr><td>Datenschutzerklärung</td><td><a href="${privacyUrl}" target="_blank">${privacyUrl}</a></td></tr>`;
  }

  if (cookies && cookies.length > 0) {
    description += '<tr><td>Cookies</td><td>';

    // eslint-disable-next-line no-restricted-syntax
    for (const { name, expire } of cookies) {
      description += `${name} (Laufzeit: ${expire})<br />`;
    }

    description += '</td></tr>';
  }

  description += '</tbody></table></div>';

  return description;
}
